import {
    DangerZoneView,
    EmailView,
    GeneralPageContent,
    GeneralView,
    LoginActivityView,
    PasswordView,
    ProfileView,
    WorkspaceView
} from '@domains/account/views'
import {AccountLayout} from '@shared/components'
import {AccountNs, type SidebarNs, UserNs} from '@shared/types'
import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router'
import {getAccountResolver} from '@domains/account/resolvers/get-account.resolver'
import {getGeneralInfoResolver} from '@domains/account/resolvers/get-general-info.resolver'
import {getLoginActivityResolver} from '@domains/account/resolvers/get-login-activity.resolver'

export const accountRoutes = [
    {
        path: '/account',
        name: AccountNs.AccountRouteEnums.ACCOUNT,
        beforeEnter: [
            (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
                getAccountResolver(to, from, next)
            }
        ],
        component: AccountLayout,
        redirect: {name: AccountNs.AccountRouteEnums.PROFILE},
        meta: {
            breadcrumb: 'Account',
            data: {
                menu: [
                    {
                        menuItems: [
                            {
                                name: AccountNs.AccountRouteEnums.PROFILE,
                                label: 'Profile',
                                icon: 'User'
                            },
                            {
                                name: AccountNs.AccountRouteEnums.EMAIL,
                                label: 'Email',
                                icon: 'Mail'
                            },
                            {
                                name: AccountNs.AccountRouteEnums.PASSWORD,
                                label: 'Password',
                                icon: 'Lock',
                                provider: UserNs.AuthProvider.LOCAL
                            },
                            {
                                name: AccountNs.AccountRouteEnums.GENERAL,
                                label: 'General',
                                icon: 'UserCog'
                            }
                        ]
                    }
                ]
            } as SidebarNs.SidebarContent
        },
        children: [
            {
                path: 'profile',
                name: AccountNs.AccountRouteEnums.PROFILE,
                component: ProfileView,
                meta: {
                    breadcrumb: 'Profile'
                }
            },
            {
                path: 'email',
                name: AccountNs.AccountRouteEnums.EMAIL,
                component: EmailView,
                meta: {
                    breadcrumb: 'Email'
                }
            },
            {
                path: 'password',
                name: AccountNs.AccountRouteEnums.PASSWORD,
                component: PasswordView,
                meta: {
                    breadcrumb: 'Password'
                },

            },
            {
                path: 'general',
                name: AccountNs.AccountRouteEnums.GENERAL,
                component: GeneralPageContent,
                redirect: {name: AccountNs.AccountRouteEnums.GENERAL_PAGE},
                meta: {
                    breadcrumb: 'General'
                },
                beforeEnter: [
                    (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
                        getGeneralInfoResolver(to, from, next)
                    }
                ],
                children: [
                    {
                        path: '',
                        name: AccountNs.AccountRouteEnums.GENERAL_PAGE,
                        component: GeneralView,
                        meta: {
                            activeMenu: AccountNs.AccountRouteEnums.GENERAL
                        }
                    },
                    {
                        path: 'workspace/leave/:workspaceId',
                        name: AccountNs.AccountRouteEnums.LEAVE_WORKSPACE,
                        component: WorkspaceView,
                        meta: {
                            breadcrumb: 'Leave Workspace',
                            activeMenu: AccountNs.AccountRouteEnums.GENERAL,
                            data: {
                                mode: 'LEFT'
                            } as AccountNs.WorkspaceRouteMetaData
                        }
                    },
                    {
                        path: 'workspace/delete/:workspaceId',
                        name: AccountNs.AccountRouteEnums.DELETE_WORKSPACE,
                        component: WorkspaceView,
                        meta: {
                            breadcrumb: 'Delete Workspace',
                            activeMenu: AccountNs.AccountRouteEnums.GENERAL,
                            data: {
                                mode: 'DELETE'
                            } as AccountNs.WorkspaceRouteMetaData
                        }
                    },
                    {
                        path: 'login-activity',
                        name: AccountNs.AccountRouteEnums.LOGINACTIVITY,
                        component: LoginActivityView,
                        meta: {
                            breadcrumb: 'Login Activity',
                            activeMenu: AccountNs.AccountRouteEnums.GENERAL
                        },
                        beforeEnter: [
                            (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
                                getLoginActivityResolver(to, from, next)
                            }
                        ]
                    },
                    {
                        path: 'danger-zone',
                        name: AccountNs.AccountRouteEnums.DANGERZONE,
                        component: DangerZoneView,
                        meta: {
                            breadcrumb: 'Danger Zone',
                            activeMenu: AccountNs.AccountRouteEnums.GENERAL
                        }
                    }
                ]
            }
        ]
    }
]
